<template>
  <div v-if="data.show" class="cardPartner">
    <div class="container">
      <div class="close" @click="data.close">
        <i class="fa fa-times" title="FECHAR" />
      </div>
      <div class="card column jutify-center">
        <div class="title row align-center">
          <label>ID {{ data.id_doutor }}</label> &nbsp; {{ data.nome }}
        </div>
        <div v-if="data.loader" class="row justify-center">
          <Loader layout="mini" />
        </div>
        <div class="content row column-s wrap" v-else>
          <div class="section grid-12">CADASTRO ({{ data.status_cadastro }})</div>

          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>PJ</label>{{ data.status_pj }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>PF</label>{{ data.status_pf }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Sócio</label>{{ data.status_doutor_socio }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Selfie Documento</label>{{ data.status_documentos_selfie_doc }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Apto:</label> {{ data.apto ? "apto" : "não apto" }}
          </div>
          <div v-if="data.pendencias" class="section grid-12">PENDÊNCIAS</div>
          <div v-if="data.pendencias" class="column">
            {{ data.pendencias }}
          </div>

          <div class="section grid-12">ATUAÇÃO</div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Atendimentos:</label> {{ data.atendimentos }}
          </div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Atendimentos últimos 30 dias:</label> {{ data.atd_ult_30_dias }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Pagamentos:</label> {{ data.pagamentos | money }}
          </div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Pagamentos últimos 30 dias:</label> {{ data.pg_ult_30_dias | money }}
          </div>

          <div class="section grid-12">ENGAJAMENTO</div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Último acesso:</label> {{ data.dh_ultimo_acesso | date }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Disponível:</label> {{ data.disponibilidade ? "Sim" : "Não" }}
          </div>
          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Disponível última vez:</label>
            {{ data.dh_atualizacao_disponibilidade | date }}
          </div>

          <div class="section grid-12">INFORMAÇÕES</div>
          <div class="grid-5 grid-6-m grid-12-s column">
            <label>Razão Social:</label> {{ data.razao_social }}
          </div>
          <div class="grid-4-g grid-6-m grid-12-s column">
            <label>E-mail:</label> {{ data.email }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Celular:</label> {{ data.celular | phone }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Fone:</label> {{ data.fone | phone }}
          </div>

          <div class="grid-3-g grid-6-m grid-12-s column">
            <label>Cidade:</label> {{ data.cidade }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Técnicos:</label> {{ data.tecnicos }}
          </div>
          <div class="grid-2-g grid-6-m grid-12-s column">
            <label>Distância:</label> {{ data.distancia }}.0 km
          </div>
        </div>
        <Button layout="green-go" @click="data.action" :loader="data.loader">DEFINIR COMO PARCEIRO</Button>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "CardPartner",
  components: { Button, Loader },
  props: { data: Object },
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.cardPartner
  label
    @include label

  .container
    position: absolute
    width: 80%
    margin-left: -5%
    z-index: 888
    top: 100px
    @media (min-width: $small)
      left: 50%
      margin-left: -32%
      width: 60%

    .card
      @include card
      width: 98%
      line-height: 35px
      .title
        font-size: 23px
        font-weight: bold
        margin-bottom: 20px
      button
        margin-top: 30px
      .content
        height: 350px
        overflow-y: auto
        padding-bottom: 60px
        .section
          color: $orange-1
          font-weight: bold
          margin-top: 17px
          font-size: 17px
          height: 14px
        label
          margin-bottom: -8px
        .column
          margin: 17px 3px
          @media (max-width: $small)
            margin: 9px 0
            text-align: center
        .status
          margin-top: 23px
    .close
        @include close
  .mask
    @include mask
    z-index: 613
</style>
